export enum RatPosition {
  Right = 'right',
  Left = 'left',
  FirstFloor = 0,
  SecondFloor = 1,
}
